import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('dfo_consume_child_issues_progress_schema');
	},
};
